<template>
  <div>
    <vs-prompt
      style="z-index: 100000"
      @cancel="fieldValue = ''"
      @accept="acceptFieldValue"
      @close="closeFieldValue"
      :active.sync="activeFieldValuePrompt"
    >
      <div class="con-exemple-prompt">
        <span>Enter field value</span>
        <vs-input placeholder="Value" vs-placeholder="Value" v-model="fieldValue" class="mt-3 w-full" />
      </div>
    </vs-prompt>

    <vs-popup fullscreen title="Planday User" :active.sync="popupActive">
      <div v-if="selectedUser">
        <div v-if="selectedUser.warnings.length > 0">
          <vx-card class="mt-8 mb-12">
            <vs-list>
              <vs-list-header title="Warnings" color="warning"></vs-list-header>

              <vs-list-item
                :key="indexWarning"
                v-for="(warning, indexWarning) in selectedUser.warnings"
                :title="indexWarning + 1 + '. ' + warning"
              ></vs-list-item>
            </vs-list>
          </vx-card>
        </div>

        <vs-table ref="table" class="mt-8" :max-items="100" :data="selectedUser.identities">
          <template slot="thead">
            <vs-th>Service</vs-th>
            <vs-th>Portal ID</vs-th>
            <vs-th>Portal Name</vs-th>
            <vs-th>First Name</vs-th>
            <vs-th>Last Name</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>SSN</vs-th>
            <vs-th>Match</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-category">{{ tr.serviceKey }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ tr.portalId }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ tr.portalName }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click.stop="onEditField('firstName', tr)"
                    />
                    {{ tr.employee.firstName }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click.stop="onEditField('lastName', tr)"
                    />
                    {{ tr.employee.lastName }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click.stop="onEditField('email', tr)"
                    />
                    {{ tr.employee.email }}
                  </p>
                </vs-td>
                <!--
                <vs-td>
                  <p class="product-category">
                    <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="onEditField('username', tr)" />
                    {{ tr.employee.userName }}
                  </p>
                </vs-td>
                -->
                <vs-td>
                  <p class="product-category">
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click.stop="onEditField('ssn', tr)"
                    />
                    {{ tr.employee.ssn }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ tr.matchType }}</p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-popup>

    <h3>Planday - Users</h3>

    <!-- <div style="text-align: right">
      <vs-button @click="syncUsers" id="sync-users-button" class="mt-4"
        >Sync Users
      </vs-button>
    </div> -->

    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="users"
      @selected="onUserClicked(selected)"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{ users.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : users.length }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-checkbox v-model="showWarningsOnly" class="mr-4">Show warnings only</vs-checkbox>
      </div>

      <template slot="thead">
        <vs-th>Name</vs-th>
        <vs-th>Email</vs-th>
        <vs-th sort-key="numIdentities">Num. Identities</vs-th>
        <vs-th>OK</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">
                {{ tr.identities[0].employee.firstName }}
                {{ tr.identities[0].employee.lastName }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ tr.identities[0].employee.email }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.numIdentities }}</p>
            </vs-td>
            <vs-td>
              <vs-icon
                v-if="tr.warnings.length == 0"
                icon="check"
                size="small"
                color="white"
                bg="lightgreen"
                round
              ></vs-icon>
              <vs-icon
                v-if="tr.warnings.length > 0"
                icon="minus"
                size="small"
                color="white"
                bg="red"
                round
              ></vs-icon>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedIdentity: null,

      activeFieldValuePrompt: false,
      fieldValue: "",
      fieldServiceKey: null,
      fieldName: null,
      fieldPlandayUserId: null,
      fieldPortalId: null,
      fieldEmployeeId: null,

      popupActive: false,
      selectedUser: null,

      showWarningsOnly: true,

      users: [],

      selected: [],
      itemsPerPage: 100,
      isMounted: false,
    };
  },
  watch: {
    showWarningsOnly() {
      this.getUsers();
    },
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length;
    },
  },
  methods: {
    acceptFieldValue() {
      this.$vs.loading();

      let url =
        process.env.VUE_APP_API +
        "/planday/users/" +
        this.fieldPlandayUserId +
        "?serviceKey=" +
        this.fieldServiceKey +
        "&portalId=" +
        this.fieldPortalId +
        "&employeeId=" +
        this.fieldEmployeeId +
        "&field=" +
        this.fieldName +
        "&value=" +
        this.fieldValue;

      this.$http
        .put(url)
        .then((/*resp*/) => {
          this.selectedIdentity.employee[this.fieldName] = this.fieldValue;
          //this.users = resp.data;
          //console.log(this.users[0]);

          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Planday User field updated",
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not update Planday User field:" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    closeFieldValue() {},

    onEditField: function (field, identity) {
      this.selectedIdentity = identity;

      this.fieldName = field;
      this.fieldServiceKey = identity.serviceKey;
      this.fieldPlandayUserId = this.selectedUser.id;
      this.fieldPortalId = identity.portalId;
      this.fieldEmployeeId = identity.employee.id;

      this.activeFieldValuePrompt = true;
    },

    getUsers: function () {
      this.$vs.loading();

      let warningsOnly = "false";
      if (this.showWarningsOnly === true) {
        warningsOnly = "true";
      }

      this.$http
        .get(process.env.VUE_APP_API + "/planday/users?warningsOnly=" + warningsOnly + "&query=" + this.query)
        .then(resp => {
          this.users = resp.data;
          console.log(this.users[0]);
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not search Planday Users:" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    syncUsers: function () {
      this.$vs.loading();

      this.$http
        .post(process.env.VUE_APP_API + "/planday/users")
        .then((/*resp*/) => {
          this.getUsers();

          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Planday Users synced",
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not sync Planday Users:" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onUserClicked(user) {
      this.selectedUser = user;
      this.popupActive = true;

      console.log(this.selectedUser);
    },
  },
  created() {
    this.getUsers();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>